/*
 *
 * ApplicantDxGridContainer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { requestAction } from 'domain/typeConstants/action';
import * as actionCreators from './actions';

class ApplicantDxGridContainer extends React.PureComponent {

  handleRowDoubleClick = (record) => this.props.executeViewAction(record.id);

  handleActionExecuting = (actionName, ids) => {
    switch (actionName) {
      case requestAction.ADD:
        this.props.executeAddAction();
        break;

      case requestAction.COPY:
        this.props.executeCopyAction(ids[0]);
        break;

      case requestAction.VIEW:
        this.props.executeViewAction(ids[0]);
        break;

      case requestAction.CLOSE:
        this.props.executeCloseAction(ids);
        break;

      default:
        throw new Error('Executed a unknown action.');
    }
  };

  render() {
    const { component, viewName } = this.props;
    return React.cloneElement(component, {
      viewName,
      onActionExecuting: this.handleActionExecuting,
      onRowDoubleClick: this.handleRowDoubleClick,
    });
  }
}

ApplicantDxGridContainer.propTypes = {
  component: PropTypes.node.isRequired,
  viewName: PropTypes.string.isRequired,
  executeAddAction: PropTypes.func.isRequired,
  executeCopyAction: PropTypes.func.isRequired,
  executeViewAction: PropTypes.func.isRequired,
  executeCloseAction: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(null, mapDispatchToProps)(ApplicantDxGridContainer);
